import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=cd86be96&scoped=true"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=cd86be96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd86be96",
  null
  
)

export default component.exports